import { useParams } from 'react-router-dom';

interface RouteParams {
    orderId: string;
    orderRoleId: string;
}

/**
 * Please use this hook inside CandidateOfferRoutes only as params type is casted.
 */
export function useOfferRouteParams() {
    const { orderId, orderRoleId } = useParams<keyof RouteParams>() as RouteParams;

    return { orderId, orderRoleId };
}
